import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=3fcb8ee4&scoped=true&"
import script from "./Environment.vue?vue&type=script&lang=js&"
export * from "./Environment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb8ee4",
  null
  
)

export default component.exports